"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUUID = void 0;
const validation_1 = require("../validator/validation");
const uuidRe = /^[0-9a-fA-F]{4}(?:[0-9a-fA-F]{4}-){4}[0-9a-fA-F]{12}$/;
function matchesUUID(value) {
    return uuidRe.test(value);
}
exports.isUUID = validation_1.isString.which((0, validation_1.satisfiesPredicate)(matchesUUID));
//# sourceMappingURL=uuid.js.map